import { useState } from 'react';
import { X, Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

/** Editor de lista de textos (serviços, produtos, requisitos). */
export const ListEditor = ({ id, items, onChange, placeholder, max = 20, testId }) => {
  const [value, setValue] = useState('');
  const add = () => {
    const v = value.trim();
    if (!v || items.includes(v) || items.length >= max) return;
    onChange([...items, v]);
    setValue('');
  };
  return (
    <div data-testid={testId}>
      <div className="flex gap-2">
        <Input id={id} value={value} onChange={(e) => setValue(e.target.value)} maxLength={80} placeholder={placeholder} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} data-testid={`${testId}-input`} />
        <Button type="button" variant="secondary" className="border border-white/10" onClick={add} disabled={!value.trim() || items.length >= max} data-testid={`${testId}-add-button`}>
          <Plus /> Adicionar
        </Button>
      </div>
      {items.length > 0 ? (
        <ul className="mt-3 flex flex-wrap gap-2">
          {items.map((it) => (
            <li key={it} className="inline-flex items-center gap-1.5 rounded-md border border-white/10 bg-white/[0.04] py-1 pl-2.5 pr-1 text-sm">
              {it}
              <button type="button" onClick={() => onChange(items.filter((x) => x !== it))} aria-label={`Remover ${it}`} className="grid h-5 w-5 place-items-center rounded text-muted-foreground hover:bg-white/10 hover:text-foreground">
                <X className="h-3 w-3" />
              </button>
            </li>
          ))}
        </ul>
      ) : <p className="mt-2 text-xs text-muted-foreground">Nenhum item adicionado.</p>}
      <p className="mt-1 text-[11px] text-muted-foreground">{items.length}/{max}</p>
    </div>
  );
};
